import {batch} from 'react-redux';
import type {Middleware, AnyAction, MiddlewareAPI, Dispatch} from 'redux';

import {isTruthy} from '~shared/utils';

import {batchActions} from '../actions';
import type {WikiDispatch} from '../types';

export const batchMiddleware: Middleware =
    (store: MiddlewareAPI<WikiDispatch>) => (next: Dispatch<AnyAction>) => (action: AnyAction) => {
        if (batchActions.match(action)) {
            const actionsToDispatch = action.payload.filter(isTruthy);

            if (actionsToDispatch.length === 1 && actionsToDispatch[0]) {
                return next(actionsToDispatch[0]);
            }

            batch(() => {
                actionsToDispatch.forEach((childAction) => {
                    store.dispatch(childAction);
                });
            });
        }

        return next(action);
    };
